module.exports = __webpack_public_path__ + "img/video-scholarship@1x.d71f48ba.jpg";